<div class="annuaire-container">
    <frg-cards class="annuaire-card" title="Annuaire des correspondants">
        <div class="card">
            <div class="card-body-correspondant">
                <form [formGroup]="searchCorrespondantForm" (ngSubmit)="submitSearchCorrespondant()"
                    *ngIf="searchCorrespondantForm">
                    <frg-form-input label="Spécialité" id="speciality" type="ngSelect" [selectValue]="refSpecialite"
                        [formGroup]="searchCorrespondantForm" [control]="searchCorrespondantForm.get('speciality')">
                    </frg-form-input>
                    <frg-form-input label="Nom" id="nom" type="text" placeholder="Ex: Dupont"
                        [formGroup]="searchCorrespondantForm" [control]="searchCorrespondantForm.get('nom')"
                        class="search-form-input align">
                    </frg-form-input>
                    <frg-form-input label="Code postal" id="codePostal" type="text" placeholder="Ex: 44000"
                        [formGroup]="searchCorrespondantForm" [control]="searchCorrespondantForm.get('codePostal')"
                        class="search-form-input align">
                    </frg-form-input>
                    <frg-form-input label="Ville" id="ville" type="text" placeholder="Ex: Nantes"
                        [formGroup]="searchCorrespondantForm" [control]="searchCorrespondantForm.get('ville')"
                        class="search-form-input align">
                    </frg-form-input>
                    <frg-button [type]="'submit'" class="search-button" [backgroundColor]="'var(--primary)'">Lancer la
                        recherche</frg-button>
                </form>
            </div>
            <div class="link-web-site" (click)="redirectToSiteAnnuaire()">
                Site web de l'annuaire de santé
            </div>
        </div>

    </frg-cards>
    <frg-cards class="infos-card" [border]="false" [title]="correspondantsFiltred ? 'Liste des résultats de la recherche' : ''">
        <div class="card-body-infos">
            <div class="correspondants-list" *ngIf="correspondantsFiltred">
                <div class="correspondants" *ngFor="let correspondant of correspondantsFiltred"
                    (click)="openDetails(correspondant)">
                    <div class="correspondant-name">
                        <p>{{correspondant.nom ? correspondant.nom : ''}} {{correspondant.prenom ?
                            correspondant.prenom : ''}}</p>
                    </div>
                    <div [ngClass]="{'badge': true, 'annuaire': correspondant.isFromAnnuaire, 'repertoire': !correspondant.isFromAnnuaire}">
                        {{ correspondant.isFromAnnuaire ? 'Annuaire de santé' : 'Répertoire du cabinet'}}
                    </div>
                </div>
                <div class="no-info" *ngIf="correspondantsFiltred.length === 0">
                    <p>Votre recherche n'a retourné aucun résultat</p>
                </div>
            </div>


            <!-- <div class="infos" *ngIf="correspondantInfos">
                <div class="identite-civile">
                    <div class="nom-prenom">
                        {{correspondantInfos.titre ? correspondantInfos.titre : ''}} {{correspondantInfos.prenom ?
                        correspondantInfos.prenom : ''}} {{correspondantInfos.nom ? correspondantInfos.nom : ''}}
                    </div>
                    <div class="specialite">
                        {{specialiteName}}
                    </div>
                    <div class="secteur">
                        Secteur : <span>{{correspondantInfos.secteur ? correspondantInfos.secteur : '- -'}}</span>
                    </div>
                </div>
                <div class="adresse-telephone">
                    <div class="adresses">
                        <div class="adresse1">
                            Adresse : <span>{{correspondantInfos.adresse1 ? correspondantInfos.adresse1 : '-
                                -'}}</span>
                        </div>
                        <div class="adresse2" *ngIf="correspondantInfos.adresse2">
                            Adresse 2 : <span>{{correspondantInfos.adresse2}}</span>
                        </div>
                        <div class="adresse3" *ngIf="correspondantInfos.adresse3">
                            Adresse 3 : <span>{{correspondantInfos.adresse3}}</span>
                        </div>
                        <div class='code-ville'>
                            {{correspondantInfos.codePostal ? correspondantInfos.codePostal : '- -'}}
                            {{correspondantInfos.ville ? correspondantInfos.ville : '- -'}}
                        </div>
                    </div>
                    <div class="telephones">
                        <div class="telephone1">
                            Téléphone 1 : <span>{{correspondantInfos.telephone1 ? correspondantInfos.telephone1 : '-
                                -'}}</span>
                        </div>
                        <div class="telephone2" *ngIf="correspondantInfos.telephone2">
                            Téléphone 2 : <span>{{correspondantInfos.telephone2}}</span>
                        </div>
                        <div class="portable1">
                            Portable 1 : <span>{{correspondantInfos.portable1 ? correspondantInfos.portable1 : '-
                                -'}}</span>
                        </div>
                        <div class="portable2" *ngIf="correspondantInfos.portable2">
                            Portable 2 : <span>{{correspondantInfos.portable2}}</span>
                        </div>
                        <div class="tel-perso" *ngIf="correspondantInfos.telephonePerso">
                            Téléphone personnel : <span>{{correspondantInfos.telephonePerso}}</span>
                        </div>
                        <div class="fax" *ngIf="correspondantInfos.fax">
                            Ligne fax : <span>{{correspondantInfos.fax}}</span>
                        </div>
                    </div>
                </div>
                <div class="emails">
                    <div class="email1">
                        Adresse e-Mail : <span>{{correspondantInfos.email1 ? correspondantInfos.email1 : '-
                            -'}}</span>
                    </div>
                    <div class="email2" *ngIf="correspondantInfos.email2">
                        Adresse e-Mail 2 : <span>{{correspondantInfos.email2}}</span>
                    </div>
                </div>
                <div class="hprim-cript">
                    <div class="hprim" *ngIf="correspondantInfos.passwordHprim">
                        Mot de passe HPRIM : <span>{{correspondantInfos.passwordHprim}}</span>
                    </div>
                    <div class="api-crypt" *ngIf="correspondantInfos.nomApiCrypt">
                        Nom API Crypt : <span>{{correspondantInfos.nomApiCrypt}}</span>
                    </div>
                    <div class="hprim" *ngIf="correspondantInfos.adresseApiCrypt">
                        Adresse API Crypt : <span>{{correspondantInfos.adresseApiCrypt}}</span>
                    </div>
                    <div class="rpps" *ngIf="correspondantInfos.rpps">
                        RPPS : <span>{{correspondantInfos.rpps}}</span>
                    </div>
                </div>
                <div class="info-compl">
                    <p>Informations complémentaires : <span>{{correspondantInfos.infos ?
                            correspondantInfos.infos : '-
                            -'}}</span></p>
                </div>
            </div> -->

        </div>
        <!-- <div class="button-wrapper" *ngIf="correspondantInfos">
            <frg-button [type]="'reset'" (activated)="cleanInfosCorrespondant()"
                [backgroundColor]="'var(--darkest-primary)'">
                Annuler
            </frg-button>
            <frg-button [backgroundColor]="'var(--primary)'" (click)="recordCorrespondant(correspondantInfos)">
                Enregistrer dans mon annuaire</frg-button>
        </div> -->
    </frg-cards>
</div>